<template>
  <hm-content title="">
    <div class="table-panel flex flex-between">
      <div>
        <el-button type="primary" class="mr10" size="small" @click="add">新建计划</el-button>
      </div>
      <div>
        <!-- <el-select
          size="small"
          clearable
          placeholder="选择计划类型"
          v-model="searchCondition.planType"
          class="mr10"
          filterable
        >
          <el-option
            v-for="(item, i) in planTypeList"
            :key="i"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select> -->
        <el-input
          clearable
          v-model.trim="searchCondition.planName"
          placeholder="请输入运营计划名称"
          size="small"
          class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
      </div>
    </div>
    <div>
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          :index="(index) => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planName"
          label="计划名称"
          width="200"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="categoryName"
          label="计划时间"
          width="200"
        >
          <template slot-scope="scope">
            {{ scope.row.planStartDate }}至{{ scope.row.planEndDate }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="planType"
          label="计划类型"
        >
        <template>
            人群运营
        </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalNoticeNum"
          label="通知人数"
        >
          <template slot-scope="scope">
            {{ scope.row.totalNoticeNum || 0 }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalVisitNum"
          label="访问人数"
        >
          <template slot-scope="scope">
            {{ scope.row.totalVisitNum || 0 }}
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="下单转化率"
          prop="proportion"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="状态"
          prop="planStatus"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.planStatus === 'notStart'" class="gray">
              未开始
            </div>
            <div v-else-if="scope.row.planStatus === 'running'" class="success">
              进行中
            </div>
            <div v-else-if="scope.row.planStatus === 'end'" class="gray">
              已结束
            </div>
            <div
              v-else-if="scope.row.planStatus === 'errorStop'"
              class="danger"
            >
              异常暂停
            </div>
            <div v-else-if="scope.row.planStatus === 'stop'" class="orange">
              暂停
            </div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="操作"
          width="200"
        >
          <template slot-scope="scope">
            <el-button
              @click="dataVivew(scope.row)"
              size="small"
              class="blue"
              type="text"
              >数据</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              class="blue"
              type="text"
              @click="edit(scope.row)"
              >编辑</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              @click="operate(scope.row)"
              v-if="
                scope.row.planStatus === 'notStart' ||
                scope.row.planStatus === 'end'
              "
              size="small"
              type="text"
              class="gray"
              :disabled="
                scope.row.planStatus === 'notStart' ||
                scope.row.planStatus === 'end'
              "
              >{{
                scope.row.planStatus === "errorStop" ||
                scope.row.planStatus === "stop"
                  ? "开启"
                  : "暂停"
              }}</el-button
            >
            <el-button
              @click="operate(scope.row)"
              v-else
              size="small"
              type="text"
              :class="
                scope.row.planStatus === 'errorStop' ||
                scope.row.planStatus === 'stop'
                  ? 'success'
                  : 'orange'
              "
              >{{
                scope.row.planStatus === "errorStop" ||
                scope.row.planStatus === "stop"
                  ? "开启"
                  : "暂停"
              }}</el-button
            >
            <el-divider direction="vertical"></el-divider>
            <el-button
              size="small"
              class="danger"
              type="text"
              @click="del(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      total: 0,
      list: [],
      pageSize: 10,
      currentPage: 1,
      searchCondition: {},
      type: "",
      // planTypeList:[
      //   {
      //     label: "人群运营",
      //     value: "people", 
      //   },
      //   {
      //     label: "生理轴运营",
      //     value: "physiological", 
      //   }
      // ],
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    edit(row) {
      this.$router.push({
        name: "SetMessagesPush",
        query: {
          type: "edit",
          row: JSON.stringify(row)
        }
      });
    },
    dataVivew(row) {
      this.$router.push({
        name: "PlanningData",
        query: {
          row: JSON.stringify(row)
        }
      });
    },
    add() {
      this.$router.push({
        name: "SetMessagesPush",
        query:{
            planType: 'tagGroup'
        }
      });
    },
    del(row) {
      this.$confirm("是否确认删除?", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning"
      }).then(() => {
        row.operateType = "del";
        this.$store.dispatch("operateStoreRepurchasePlan", row).then(res => {
          if (res.code === "0") {
            this.$message({
              message: " 操作成功",
              type: "success"
            });
            this.queryList();
          }
        });
      });
    },
    operate(row) {
      let params = {
        id: row.id,
        operateType: "enabledState",
        enabledState:
          row.planStatus === "errorStop" || row.planStatus === "stop"
            ? "yes"
            : "no"
      };

      this.$store.dispatch("operateStoreRepurchasePlan", params).then(res => {
        if (res.code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.queryList();
        }
      });
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
        planType: "tagGroup",
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "queryAgeGroupPlanInfoPageList",
        params
      );
      if (code === "0") {
        const { total, records } = result;
        records.forEach(v => {
          v.proportion = v.totalNoticeNum
            ? (v.totalPayNum / v.totalNoticeNum).toFixed(2) + "%"
            : "0%";
        });
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang='scss' scoped>
</style>
